(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/client.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/client.js'); 


'use strict';

var trinidad = svs.core;
var _svs$components$emp_v = svs.components.emp_video_player.helpers.common,
    errorMessages = _svs$components$emp_v.errorMessages,
    getJsonLDString = _svs$components$emp_v.getJsonLDString,
    getThumbnailFromResult = _svs$components$emp_v.getThumbnailFromResult;
var spinnerHtmlClass = 'vjs-waiting';
var views = {
  MISSING: 'MISSING',
  THUMBNAIL: 'THUMBNAIL',
  VIDEO: 'VIDEO'
};

var vars = function vars() {
  return {
    logger: new trinidad.log.Logger('components:empplayer'),
    redBeeHost: svs.components.emp_video_player.data && svs.components.emp_video_player.data.host
  };
};


var setDefaultOptions = function setDefaultOptions(options) {
  options.customer = options.customer || 'SvenskaSpel';
  options.businessUnit = options.businessUnit || 'VOD';
  options.autoplay = typeof options.autoplay === 'boolean' ? options.autoplay : true;
  options.autoplay = options.autoplay ? 'any' : false;
  options.width = options.width || 800;
  return options;
};

var setEmpPlayerOptions = function setEmpPlayerOptions(options) {
  return {
    controls: true,
    ericssonexposure: {
      businessUnit: options.businessUnit,
      customer: options.customer,
      exposureApiURL: vars().redBeeHost
    }
  };
};

var setPlaybackOptions = function setPlaybackOptions(options) {
  return {
    autoplay: options.autoplay
  };
};

var loadVideoComponent = function loadVideoComponent(callback) {
  svs.core.module.load('/cl/libs/empplayer2', undefined, function (error) {
    if (error) {
      vars().logger.error('failed to load empplayer2 component');
      callback(error);
    } else {
      vars().logger.debug('loaded empplayer2 component');
      callback();
    }
  }, false, true);
};

var setEvents = function setEvents(player) {
  var _empPlayer$Events = empPlayer.Events,
      FIRST_PLAY = _empPlayer$Events.FIRST_PLAY,
      ERROR = _empPlayer$Events.ERROR;
  player.on(FIRST_PLAY, function () {
    svs.components.analytics.trackEvent({
      action: 'Start',
      category: 'Video',
      opt_label: player.getMediaInfo().title,
      opt_value: 1
    });
  });
  player.on(ERROR, function (error) {
    vars().logger.info('Could not load video!', error);
    setTimeout(function () {
      player.removeClass(spinnerHtmlClass);
    }, 1000);
  });
};

var startVideoPlayer = function startVideoPlayer(node, options) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var videoNode = node.querySelector('video');

  if (node.querySelector('.emp-thumbnail')) {
    node.querySelector('.emp-thumbnail').style.display = 'none';
  }

  options = setDefaultOptions(options);
  var empPlayerOptions = setEmpPlayerOptions(options);
  var playbackOptions = setPlaybackOptions(options);
  var exposure = empPlayer.getExposure(empPlayerOptions.ericssonexposure);
  var player;
  exposure.login('', '', function (response) {
    if (response.success) {
      empPlayerOptions.ericssonexposure.sessionToken = response.session.sessionToken;
      player = empPlayer(videoNode, empPlayerOptions, function () {
        player.addClass(spinnerHtmlClass);
        setEvents(player, node);
        player.startPlaybackV2(options.assetId, playbackOptions);
        callback(undefined, player);
      });
    } else {
      vars().logger.warn('empplayer2 login failed', response);
      callback(response);
    }
  });
};


var getMeta = function getMeta(options) {
  var dfd = jQuery.Deferred();

  if (!options) {
    vars().logger.warn('No option parameter.');
    return;
  }

  options = setDefaultOptions(options);
  var requestUri = "".concat(vars().redBeeHost, "/v1/customer/").concat(options.customer) + "/businessunit/".concat(options.businessUnit, "/content/asset/").concat(options.assetId) + "?fieldSet=ALL&onlyPublished=true&includeUserData=false";

  if (options.assetId) {
    $.getJSON(requestUri).done(function (result) {
      var jsonLDTags = getJsonLDString(result);

      if (!jsonLDTags) {
        vars().logger.warn("Failed to create JSON-LD script for video: ".concat(options.assetId));
        jsonLDTags = '';
      }

      var thumbnailSrc = getThumbnailFromResult(result);

      if (thumbnailSrc) {
        thumbnailSrc += "?w=".concat(options.width);
      }

      var elementModel = {
        assetId: options.assetId,
        businessUnit: options.businessUnit,
        customer: options.customer,
        jsonLDTags: jsonLDTags,
        thumbnailSrc: thumbnailSrc
      };
      dfd.resolve(elementModel);
    }).catch(function (error) {
      var message = "CLIENT: ".concat(errorMessages.failedWithAssetId, "=").concat(options.assetId, ". ");
      message += "Message: ".concat(error.responseText || error.statusText);
      vars().logger.warn(message);
      dfd.reject(error);
    });
  } else {
    vars().logger.warn(errorMessages.noAssetId);
    dfd.reject(errorMessages.noAssetId);
  }

  return dfd;
};


var loadView = function loadView(node, view, model, action) {
  var _svs$components$emp_v2 = svs.components.emp_video_player.templates,
      emp_video_player = _svs$components$emp_v2.emp_video_player,
      missing_video = _svs$components$emp_v2.missing_video,
      thumbnail = _svs$components$emp_v2.thumbnail,
      video_with_seo = _svs$components$emp_v2.video_with_seo;

  var addClickEvent = function addClickEvent(node, actionEvent) {
    node.addEventListener('click', function () {
      actionEvent(node);
    });
  };

  switch (view) {
    case views.VIDEO:
      node.innerHTML = video_with_seo(model);
      break;

    case views.THUMBNAIL:
      {
        if (node) {
          node.innerHTML = thumbnail(model);
          var overlayNode = node.querySelector('.js-emp-partial-overlay');

          var clickAction = function clickAction() {
            action(node, {
              assetId: model.assetId,
              businessUnit: model.businessUnit,
              customer: model.customer
            });
          };

          addClickEvent(overlayNode, clickAction);
        }

        break;
      }

    case views.MISSING:
      node.innerHTML = missing_video({});
      break;

    default:
      node.innerHTML = emp_video_player();
      break;
  }

  return node;
};

var setupVideo = function setupVideo(element, options) {
  var jQueryPromise = $.Deferred();

  if (!element) {
    return;
  }

  getMeta(options).then(function (result) {
    if (options.noThumbnail) {
      loadView(element, views.VIDEO, result);
      jQueryPromise.resolve();
    } else {
      loadView(element, views.THUMBNAIL, result, function (viewElement) {
        loadVideoComponent(function () {
          startVideoPlayer(viewElement, options);
        });
      });
      jQueryPromise.resolve();
    }
  }).catch(function (error) {
    loadView(element, views.MISSING);
    jQueryPromise.reject(error);
  });
  return jQueryPromise;
};

var setupVideoFromAttributes = function setupVideoFromAttributes(element) {
  if (!element) {
    return;
  }

  var parent = element && element.parentNode;
  var attributes = parent.attributes;
  var options = {
    assetId: attributes['data-assetid'] && attributes['data-assetid'].value,
    businessUnit: attributes['data-businessunit'] && attributes['data-businessunit'].value,
    customer: attributes['data-customer'] && attributes['data-customer'].value
  };
  return setupVideo(parent, options);
};

svs.components.emp_video_player.helpers.client = {
  getMeta: getMeta,
  loadVideoComponent: loadVideoComponent,
  loadView: loadView,
  setupVideo: setupVideo,
  setupVideoFromAttributes: setupVideoFromAttributes,
  startVideoPlayer: startVideoPlayer
};
 })(window);